export default __webpack_public_path__ + "static/media/CharlesIV.55ccc4e1.jpg";